<div id="grid2ConfigDiv" class="grid-container">
  <!--Testata configurazione colonne-->
  <dx-data-grid
    id="gridConfig3"
    [dataSource]="gridConf.cols"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    [showBorders]="false"
    [showColumnLines]="true"
    [showRowLines]="true"
    [allowColumnResizing]="true"
    (onRowUpdated)="onConfigRowUpdating($event)"
    [height]="(windowSize.contentHeight ?? 0) - tabsHeight"
    (onToolbarPreparing)="hideButtons($event)"
    (onEditingStart)="saveData()"
  >
    <dxi-column
      [allowEditing]="false"
      dataField="dataField"
      [caption]="'Id' | siaTranslate"
    ></dxi-column>
    <!-- <dxi-column
    [allowEditing]="false"
    dataField="caption"
    [caption]="'Nome' | siaTranslate"
  ></dxi-column> -->
    <dxi-column
      dataField="visibleIndex"
      [caption]="'Ord.' | siaTranslate"
      dataType="number"
      alignment="center"
      sortOrder="asc"
      width="80px"
      [visible]="false"
    ></dxi-column>
    <!-- SELETTORE COLONNE -->
    @if (gridConf.actionColumnChooserEnabled) {
    <dxi-column
      [caption]="'Selettore Colonne' | siaTranslate"
      alignment="center"
    >
      <dxi-column
        dataField="allowHiding"
        [caption]="'Consenti' | siaTranslate"
        dataType="boolean"
        width="70px"
      ></dxi-column>
      <dxi-column
        dataField="showInColumnChooser"
        [caption]="'Visualizzabile nel Selettore' | siaTranslate"
        dataType="boolean"
        width="70px"
      ></dxi-column>
    </dxi-column>
    }
    <!-- FILTRI COLONNA -->
    <dxi-column [caption]="'Filtri Colonna' | siaTranslate" alignment="center">
      <dxi-column
        dataField="selectedFilterOperation"
        [caption]="'Filtro Predefinito' | siaTranslate"
        width="100px"
      >
        <dxo-lookup
          [dataSource]="gridConfFiltersTypes"
          displayExpr="name"
          valueExpr="id"
        >
        </dxo-lookup>
      </dxi-column>
      <dxi-column
        dataField="allowHeaderFiltering"
        [caption]="'Su Header' | siaTranslate"
        dataType="boolean"
        width="70px"
      ></dxi-column>

      <dxi-column
        dataField="allowSorting"
        [caption]="'Ordinabile' | siaTranslate"
        dataType="boolean"
        width="70px"
      ></dxi-column>

      <dxi-column
        dataField="sortOrder"
        [caption]="'Ordinamento' | siaTranslate"
        dataType="string"
        width="100px"
      >
        <dxo-lookup
          [dataSource]="gridConfSortOrderTypes"
          displayExpr="name"
          valueExpr="id"
        >
        </dxo-lookup>
      </dxi-column>
      <dxi-column
        dataField="sortIndex"
        [caption]="'Sort.(idx)' | siaTranslate"
        dataType="number"
        alignment="center"
        width="80px"
      ></dxi-column>
    </dxi-column>
    <!-- RAGRUPPAMENTO -->
    <dxi-column [caption]="'Ragruppamento' | siaTranslate" alignment="center">
      <dxi-column
        dataField="summaryColGroupEnable"
        [caption]="'Su Gruppi Colonna' | siaTranslate"
        dataType="boolean"
        width="70px"
      ></dxi-column>
      <dxi-column
        dataField="summaryColEnable"
        [caption]="'Su Colonna' | siaTranslate"
        dataType="boolean"
        width="70px"
      ></dxi-column>
      <dxi-column
        dataField="summaryType"
        alignment="center"
        [caption]="'Totalizzazione' | siaTranslate"
        width="100px"
      >
        <dxo-lookup
          [dataSource]="gridConfSummaryTypes"
          displayExpr="name"
          valueExpr="id"
        >
        </dxo-lookup>
      </dxi-column>
      <dxi-column
        dataField="alignByColumn"
        [caption]="'Allineato alla colonna' | siaTranslate"
        dataType="boolean"
        width="70px"
      ></dxi-column>
      <dxi-column
        dataField="summaryDisplayFormat"
        caption="Formato"
      ></dxi-column>
    </dxi-column>

    <dxo-editing
      mode="batch"
      refreshMode="repaint"
      [allowUpdating]="true"
      [selectTextOnEditStart]="selectTextOnEditStart"
      [startEditAction]="startEditAction"
    >
    </dxo-editing>

    <dxo-selection mode="single"></dxo-selection>
    <dxo-remote-operations [sorting]="true" [paging]="true">
    </dxo-remote-operations>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
    <dxo-load-panel [enabled]="false"></dxo-load-panel>
    <dxo-header-filter [visible]="false"></dxo-header-filter>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-search-panel [visible]="false"></dxo-search-panel>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
  </dx-data-grid>
</div>
